import { render } from "./LabsView.vue?vue&type=template&id=56def554&scoped=true"
import script from "./LabsView.vue?vue&type=script&lang=js"
export * from "./LabsView.vue?vue&type=script&lang=js"

import "./LabsView.vue?vue&type=style&index=0&id=56def554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56def554"]])

export default __exports__